import { blackBoxEnumUrl, blackBoxTabbedRateUrl, blackBoxBusinessRateUrl } from "../components/MRQT/common/constants";
import HttpService from "./HttpService";

export interface IEnum {
    id: number,
    name: string
}

export interface IRate {
    rate?: any
}

export enum RateTypes {
    TabbedRates = "TabbedRates",
    BusinessRates = "BusinessRates",
}

export async function getEnum(param: string): Promise<IEnum[]> {
    try {
        return await HttpService.get<IEnum[]>(blackBoxEnumUrl(param), `enum:${param}`);
    }
    catch (error) {
        console.error("Error getting enums:", error);
    }
}

export async function getRates(rates) {
    try {
        const rateData = Promise.all(rates.map(async id => {
            const result = await HttpService.get(blackBoxTabbedRateUrl+id, `rates/tabbed:${id}`);
            return result;
        }));

        return rateData;
    } catch (error) {
        console.error("Error getting Rate:", error);
    }
}

export async function getRate(rateId, rateType) {
    let rateUrl = blackBoxTabbedRateUrl+rateId;
    if (rateType == RateTypes.BusinessRates) {
        rateUrl = blackBoxBusinessRateUrl+rateId;
    }
    try {
        const rateData = await HttpService.get<IRate>(rateUrl, `${rateUrl}`);

        return rateData;
    } catch (error) {
        console.error("Error getting Rate:", error);
    }
}

export interface IOptions {
    id: string;
    name: string;
    data: IEnum[]
}
